/**
 * Fields stripped before PUT contract/update.
 *
 * The object posted by the portal is the full contract fetched from the API, so it carries far
 * more than the two pages actually edit. Two groups come out:
 *
 *  - never persisted by this endpoint: they are absent from ContractRepository.Update's whitelist,
 *    so the server has always discarded them. inspectionPDF alone is ~237 kB of base64 that the
 *    server generated and the client was uploading straight back.
 *  - now sourced server-side: ContractService.UpdateAsync takes these from the contract row it has
 *    already loaded, so echoing them adds nothing and a forged value would be ignored anyway.
 *
 * Deliberately NOT stripped: signature, isSigned, name, functie, informationSubmitted, contactMe
 * and the five newsletter flags. Those are the values the portal genuinely edits, and the server's
 * whitelist copies them unconditionally — omitting any of them would write its default over the
 * stored value and, in signature's case, erase the customer's signature.
 *
 * Only for contract/update. contract/add and contract/reject-contract read several of these
 * fields from the request and must keep sending them.
 */
const FIELDS_NOT_PERSISTED = [
    "inspectionPDF",
    "contractNumber",
    "ledgerAccount",
    "objects",
    "contactId",
    "isSeprateContract",
];
const FIELDS_SOURCED_SERVER_SIDE = [
    "leadId",
    "reference",
    "department",
    "disablePurchaseOrder",
    "isDeleted",
    "remark",
    "paid",
    "payLater",
    "isContinous",
    "isCopied",
    "contractSignDate",
    "ipAddressAtSigning",
];
export const toContractUpdatePayload = (contract) => {
    const payload = Object.assign({}, contract);
    for (const field of [...FIELDS_NOT_PERSISTED, ...FIELDS_SOURCED_SERVER_SIDE]) {
        delete payload[field];
    }
    return payload;
};
